// Import Core
import React from 'react';
import styled from 'styled-components';
// Import Libraries
import { PortableText } from '@portabletext/react';
// Import Components
import PortableTextComponent from '../ui/PortableTextComponent';
import { toSlug } from '../../utils/search/toSlug';

/* Styled Components */
const SimpleContentStyles = styled.section`
	background: var(--white);
	display: flex;
	padding: var(--global-padding);
	flex-direction: column;
	align-items: center;
	gap: 80px;
	max-width: 738px;
	margin: 0 auto;
  @media(max-width: 768px) {
		padding: var(--global-padding-mobile);
    gap: 32px;
  }

	> div {
		max-width: 1440px;
    margin: 0 auto;
		ul,
		ol {
			list-style-type: disc;
			list-style-position: inside;
		}
		h1, h2, h3, h4, h5, h6 {
			padding: 24px 0;
		}
		h4 {
			text-transform: inherit;
			font-family: var(--font-family-base);
			color: rgb(185,76,82);
			font-weight: 700;
			font-size: 21px;
			line-height: 27px;
		}
		p, ul, ol {
			padding-bottom: 16px;;
		}
		a {
			color: var(--red);
			text-decoration: underline;
		}
		.portable-text_image-container {
			display: flex;
			justify-content: center;
			align-items: center;
			gap: 20px;
		}
		.portable-text_image-wrapper {
			display: flex;
			padding: 48px 0px;
			flex-direction: column;
			align-items: flex-start;
			gap: 8px;
			align-self: stretch;
      @media(max-width: 768px) {
        padding: 40px 0;
      }
			.portable-text_image {
				object-fit: cover;
				width: 100%;
				height: 100%;
				max-width: inherit;
				max-height: 337px;
			}
			figcaption {
				color: var(--red-75);
				text-transform: capitalize;
			}
		}
		.portable-text_video-wrapper {
			margin: 48px 0px;
		}
	}
`;

/* Render Component */
const SimpleContent = ({ content, addToAnchor, anchorTitle,excerpt }) => {
	if (typeof content === 'string') {
		return (
			<SimpleContentStyles id={addToAnchor ? `anchor_${toSlug(anchorTitle)}` : ''} className={`simple-content ${addToAnchor && 'anchor-link'}`}>
				{content}
			</SimpleContentStyles>
		);
	} else {
		return (
			<SimpleContentStyles id={addToAnchor ? `anchor_${toSlug(anchorTitle)}` : ''} className={`simple-content ${addToAnchor && 'anchor-link'}`}>
				<div>
					{excerpt && <p>{excerpt}</p>}
					{content && (
						<PortableText value={content} components={PortableTextComponent} />
					)}
				</div>
			</SimpleContentStyles>
		);
	}
};

export default SimpleContent;
